import { createContext, FC, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/compat/router';
import { TerritoryTab, TerritoryTabProps } from './tab';
import { TerritorySelectedTab } from '../constants';
import { getFeatureFlag } from '../../FeatureFlags/getFeatureFlag';
import getTerritoryPageUrl from '../../../services/pagesUrl/getTerritoryPageUrl';

export const TerritoryTabContext = createContext({} as TerritoryTab);

const TerritoryTabProvider: FC<TerritoryTabProps> = ({ children, initialTerritoryTab }) => {
  const router = useRouter();
  const territorySlug = router?.query.territorySlug;

  const defaultTab = initialTerritoryTab || TerritorySelectedTab.explore;
  const [activeTab, setActiveTab] = useState<TerritorySelectedTab>(defaultTab);

  const openTerritoryTab = (tab: TerritorySelectedTab) => {
    setActiveTab(tab);

    const territoryPageUrl = getTerritoryPageUrl(`${territorySlug}/${tab}`);

    if (getFeatureFlag('territoryPageV2')) {
      router?.push(`/t/${territorySlug}/${tab}`);
    } else {
      router?.push(territoryPageUrl as string);
    }
  };

  useEffect(() => {
    if (router?.asPath.includes('explore')) {
      setActiveTab(TerritorySelectedTab.explore);
    }
  }, [router?.asPath]);

  const providerValue = useMemo(() => ({ activeTab, openTerritoryTab }), [activeTab, openTerritoryTab]);

  return <TerritoryTabContext.Provider value={providerValue}>{children}</TerritoryTabContext.Provider>;
};

export default TerritoryTabProvider;
